import React, { useEffect } from 'react';

// routing
import { NavLink as Link } from 'react-router-dom';

// alert
import { warning } from '../../util/Alert';

// redux
import { useDispatch } from 'react-redux';
import { STORAGE_KEYS } from '../../util/permissions';
import { usePermission } from '../context/PermissionProvider';

// types
import { UNSET_ADMIN } from '../../store/admin/types';
import { ReactComponent as Settlement } from '../../assets/images/settlement.svg';
import { ReactComponent as HostSettleMent } from '../../assets/images/hostSettlement.svg';

//MUI

// jquery
import $ from 'jquery';
import { useNavigate } from 'react-router-dom';
import { projectName } from '../../util/Config';

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginType = sessionStorage.getItem(STORAGE_KEYS.loginType) || '';
  const { canSee } = usePermission();

  const handleLogout = () => {
    const data = warning();
    data.then((isLogout) => {
      if (isLogout) {
        dispatch({ type: UNSET_ADMIN });
        navigate('/');
      }
    });
  };

  useEffect(() => {
    $('').addClass('submenu-margin');
  }, []);
  return (
    <>
      <div className="page-sidebar">
        <Link to="/admin/dashboard">
          <span className="logo text-danger text-capitalize">
            {projectName}
          </span>
        </Link>
        <ul className="list-unstyled accordion-menu">
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Dashboard"
          >
            <Link to="/admin/dashboard" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="activity"></i>
              </span>
              Dashboard
            </Link>
          </li>

          {canSee('admin/banner') && (
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Banner">
            <Link to="/admin/banner" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="image"></i>
              </span>
              Banner
            </Link>
          </li>
          )}
          {/* <li data-bs-toggle="tooltip" data-bs-placement="top" title="User">
     <Link to="/admin/user" className="nav-link">
       <span className="sidenav__icon">
         <i data-feather="users"></i>
       </span>
       User
     </Link>
   </li> */}
          {(canSee('admin/user') || canSee('admin/fakeUser') || canSee('admin/liveuser')) && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="User"
            className="pointer-cursor"
          >
            <a
              href={() => false}
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
            >
              <span className="sidenav__icon">
                <i data-feather="users"></i>
              </span>
              Users
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canSee('admin/user') && (
              <li>
                <Link to="/admin/user" className="nav-link">
                  <i className="far fa-circle"></i>Real
                </Link>
              </li>
              )}
              {canSee('admin/fakeUser') && (
              <li>
                <Link to="/admin/fakeUser" className="nav-link">
                  <i className="far fa-circle"></i>Fake
                </Link>
              </li>
              )}
              {canSee('admin/liveuser') && (
              <li>
                <Link to="/admin/liveuser" className="nav-link">
                  <i className="far fa-circle"></i>Live
                </Link>
              </li>
              )}
            </ul>
          </li>
          )}

          {/* <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="User"
            className="pointer-cursor"
          >
            <a
              href={() => false}
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
            >
              <span className="sidenav__icon">
                <Settlement />
              </span>
              Agency Settlement
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              
              <li>
                <Link to="/admin/solved" className="nav-link">
                  <i className="far fa-circle"></i>Solved
                </Link>
              </li>

              <li>
                <Link to="/admin/pending" className="nav-link">
                  <i className="far fa-circle"></i>Pending
                </Link>
              </li>
            </ul>
          </li>

          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="User"
            className="pointer-cursor"
          >
            <a
              href={() => false}
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
            >
              <span className="sidenav__icon">
                <HostSettleMent />
              </span>
              Host Settlement
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
               
              <li>
                <Link to="/admin/hostsolved" className="nav-link">
                  <i className="far fa-circle"></i>Solved
                </Link>
              </li>

              <li>
                <Link to="/admin/hostpending" className="nav-link">
                  <i className="far fa-circle"></i>Pending
                </Link>
              </li>
            </ul>
          </li> */}

          {(canSee('admin/agency') || canSee('admin/agencyHistory') || canSee('admin/agencyRedeemRequest')) && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Theme"
            className="pointer-cursor"
          >
            <a
              href={() => false}
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
            >
              <span className="sidenav__icon">
                <i data-feather="image"></i>
              </span>
              Agency
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canSee('admin/agency') && (
              <li>
                <Link to="/admin/agency" className="nav-link">
                  <i className="far fa-circle"></i>Agency
                </Link>
              </li>
              )}
              {canSee('admin/agencyHistory') && (
              <li>
                <Link to="/admin/agencyHistory" className="nav-link">
                  <i className="far fa-circle"></i>Agency History
                </Link>
              </li>
              )}
              {canSee('admin/agencyRedeemRequest') && (
              <li>
                <Link to="/admin/agencyRedeemRequest" className="nav-link">
                  <i className="far fa-circle"></i> Agency Redeem
                </Link>
              </li>
              )}
            </ul>
          </li>
          )}
          {canSee('admin/hostRequest') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Coin Seller"
          >
            <Link to="/admin/hostRequest" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="user-check"></i>
              </span>
              Host Request
            </Link>
          </li>
          )}

          {canSee('admin/coinSeller') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Coin Seller"
          >
            <Link to="/admin/coinSeller" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="dollar-sign"></i>
              </span>
              Coin Seller
            </Link>
          </li>
          )}

          {canSee('admin/userRedeemRequest') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Redeem"
            className="pointer-cursor"
          >
            <Link to="/admin/userRedeemRequest" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="key"></i>
              </span>
              User Redeem
            </Link>
          </li>
          )}

          {canSee('admin/mainPlan') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Plan"
            className="pointer-cursor"
          >
            <Link to="/admin/mainPlan" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="layout"></i>
              </span>
              Plan
            </Link>
            {/* <ul className="">
              <li>
                <Link to="/admin/coinPlan" className="nav-link">
                  <i className="far fa-circle"></i>Coin Plan
                </Link>
              </li>
              <li>
                <Link to="/admin/vipPlan" className="nav-link">
                  <i className="far fa-circle"></i>VIP Plan
                </Link>
              </li>
            </ul> */}
          </li>
          )}
          {canSee('admin/badge') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Badges"
            className="pointer-cursor"
          >
            <Link to="/admin/badge" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="layout"></i>
              </span>
              Badges
            </Link>
          </li>
          )}
          {canSee('admin/country') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Country"
            className="pointer-cursor"
          >
            <Link to="/admin/country" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="layout"></i>
              </span>
              Country
            </Link>
          </li>
          )}
          {canSee('admin/tags') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Tags"
            className="pointer-cursor"
          >
            <Link to="/admin/tags" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="layout"></i>
              </span>
              Tags
            </Link>
          </li>
          )}
          {canSee('admin/planHistory') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Purchase Plan History"
            className="pointer-cursor"
          >
            <Link to="/admin/planHistory" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="clock"></i>
              </span>
              Plan History
            </Link>
          </li>
          )}
          {canSee('admin/game') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Game"
          >
            <Link
              to="/admin/game"
              className="nav-link"
              style={{ display: 'flex' }}
            >
              <span
                className="sidenav__icon"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <i className="far fa-gamepad" style={{ fontSize: '23px' }}></i>
              </span>
              <span> Game</span>
            </Link>
          </li>
          )}
          {canSee('admin/gameHistory') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Game History"
          >
            <Link to="/admin/gameHistory" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="hash"></i>
              </span>
              Game History
            </Link>
          </li>
          )}
          {(canSee('admin/giftCategory') || canSee('admin/gift')) && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Gift"
            className="pointer-cursor"
          >
            <a
              href={() => false}
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
            >
              <span className="sidenav__icon">
                <i data-feather="gift"></i>
              </span>
              Gift
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canSee('admin/giftCategory') && (
              <li>
                <Link
                  to="/admin/giftCategory"
                  className="nav-link"
                  onClick={() => sessionStorage.removeItem('GiftClick')}
                >
                  <i className="far fa-circle"></i>Category
                </Link>
              </li>
              )}
              {canSee('admin/gift') && (
              <li>
                <Link
                  to="/admin/gift"
                  className="nav-link"
                  onClick={() => sessionStorage.setItem('GiftClick', true)}
                >
                  <i className="far fa-circle"></i>Gift
                </Link>
              </li>
              )}
            </ul>
          </li>
          )}

          {canSee('admin/reaction') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Reaction"
          >
            <Link
              to="/admin/reaction"
              className="nav-link"
              style={{ display: 'flex' }}
            >
              <span
                className="sidenav__icon"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <i className="far fa-smile-wink" style={{ fontSize: '23px' }} />
              </span>
              Reaction
            </Link>
          </li>
          )}

          {(canSee('admin/entryEffect') || canSee('admin/avatarFrame')) && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Store"
            className="pointer-cursor"
          >
            <a
              href={() => false}
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
            >
              <span className="sidenav__icon">
                <i data-feather="loader"></i>
              </span>
              Store
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canSee('admin/entryEffect') && (
              <li>
                <Link
                  to="/admin/entryEffect"
                  className="nav-link"
                  onClick={() => sessionStorage.removeItem('GiftClick')}
                >
                  <i className="far fa-circle"></i>Entry Effect
                </Link>
              </li>
              )}
              {canSee('admin/avatarFrame') && (
              <li>
                <Link
                  to="/admin/avatarFrame"
                  className="nav-link"
                  onClick={() => sessionStorage.setItem('GiftClick', true)}
                >
                  <i className="far fa-circle"></i>Avatar Frame
                </Link>
              </li>
              )}
            </ul>
          </li>
          )}

          {/* <li data-bs-toggle="tooltip" data-bs-placement="top" title="Sticker">
            <Link to="/admin/sticker" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="anchor"></i>
              </span>
              Sticker
            </Link>
          </li> */}
          {(canSee('admin/broadcastgift') || canSee('admin/broadcastgame')) && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Broadcast"
            className="pointer-cursor"
          >
            <a
              href={() => false}
              className="add-collapse-margin"
              style={{ marginLeft: 0 }}
            >
              <span className="sidenav__icon">
                <i data-feather="radio"></i>
              </span>
              Broadcast
              <i className="fas fa-chevron-right dropdown-icon"></i>
            </a>
            <ul className="">
              {canSee('admin/broadcastgift') && (
              <li>
                <Link to="/admin/broadcastgift" className="nav-link">
                  <i className="far fa-circle"></i>Broadcast Gift
                </Link>
              </li>
              )}
              {canSee('admin/broadcastgame') && (
              <li>
                <Link to="/admin/broadcastgame" className="nav-link">
                  <i className="far fa-circle"></i>Broadcast Game
                </Link>
              </li>
              )}
            </ul>
          </li>
          )}

          {canSee('admin/theme') && (
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Theme">
            <Link to="/admin/theme" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="image"></i>
              </span>
              Theme
            </Link>
          </li>
          )}
          {canSee('admin/song') && (
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Song">
            <Link to="/admin/song" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="music"></i>
              </span>
              Song
            </Link>
          </li>
          )}
          {canSee('admin/hashtag') && (
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Hashtag">
            <Link to="/admin/hashtag" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="hash"></i>
              </span>
              Hashtag
            </Link>
          </li>
          )}
          {canSee('admin/level') && (
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Level">
            <Link to="/admin/level" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="bar-chart"></i>
              </span>
              Level
            </Link>
          </li>
          )}

          {canSee('admin/mainPost') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Post"
            className="pointer-cursor"
          >
            <Link
              to={'/admin/mainPost'}
              className="nav-link"
              style={{ marginLeft: 0 }}
            >
              <span className="sidenav__icon">
                <i data-feather="maximize"></i>
              </span>
              Post
            </Link>
            {/* <ul className="">
              <li>
                <Link to="/admin/post" className="nav-link">
                  <i className="far fa-circle"></i>Real
                </Link>
              </li>
              <li>
                <Link to="/admin/post/fake" className="nav-link">
                  <i className="far fa-circle"></i>Fake
                </Link>
              </li>
            </ul> */}
          </li>
          )}

          {canSee('admin/mainVideo') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Video"
            className="pointer-cursor"
          >
            <Link
              to={'/admin/mainVideo'}
              className="nav-link"
              style={{ marginLeft: 0 }}
            >
              <span className="sidenav__icon">
                <i data-feather="film"></i>
              </span>
              Video
            </Link>
          </li>
          )}
          {canSee('admin/reportedUser') && (
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Reported User">
            <Link to="/admin/reportedUser" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="flag"></i>
              </span>
              Reported User
            </Link>
          </li>
          )}
          {canSee('admin/complainRequest') && (
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Complain">
            <Link to="/admin/complainRequest" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="help-circle"></i>
              </span>
              Complain Request
            </Link>
          </li>
          )}

          {canSee('admin/advertisement') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Google Ad"
          >
            <Link to="/admin/advertisement" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="book"></i>
              </span>
              Google Ad
            </Link>
          </li>
          )}
          {canSee('admin/role') && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Access Roles"
            >
              <Link to="/admin/role" className="nav-link">
                <span className="sidenav__icon">
                  <i data-feather="shield"></i>
                </span>
                Access Roles
              </Link>
            </li>
          )}

          {canSee('admin/staff') && (
            <li
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Staff"
            >
              <Link to="/admin/staff" className="nav-link">
                <span className="sidenav__icon">
                  <i data-feather="users"></i>
                </span>
                Staff
              </Link>
            </li>
          )}

          {canSee('admin/auditHistory') && (
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Audit History"
          >
            <Link to="/admin/auditHistory" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="file-text"></i>
              </span>
              Audit History
            </Link>
          </li>
          )}

          {canSee('admin/setting') && (
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Setting">
            <Link to="/admin/setting" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="settings"></i>
              </span>
              Setting
            </Link>
          </li>
          )}
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Profile">
            <Link to="/admin/adminProfile" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="user"></i>
              </span>
              Profile
            </Link>
          </li>
          <li data-bs-toggle="tooltip" data-bs-placement="top" title="Logout">
            <a
              href={() => false}
              onClick={handleLogout}
              className="add-collapse-margin cursor-pointer"
              role="button"
              tabIndex={0}
            >
              <span className="sidenav__icon">
                <i data-feather="log-out"></i>
              </span>
              Logout
            </a>
          </li>
        </ul>
        <a
          href={() => false}
          id="sidebar-collapsed-toggle"
          style={{ opacity: 0, pointerEvents: 'none' }}
        >
          <i data-feather="arrow-right"></i>
        </a>
      </div>
    </>
  );
};
export default Navbar;
